export default "__VITE_ASSET__b5ab5070__"